import React, { useMemo } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';
import useCustomTable from '../tables/useCustomTable';
import Table from '../tables/Table';
import { useGetConfigurableRemoteConfigurationHistoryQuery } from '../../api/remoteConfigurationApiSlice';

const RemoteConfigurationHistory = ({show, onClose, configurable}) => {
  const { t } = useTranslation()
  const { data=[], isLoading, isSuccess, isError } = useGetConfigurableRemoteConfigurationHistoryQuery(configurable)
  const {
    tableProps,
    paginationProps,
    tableFilterProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
  });

  const columns = useMemo(() => [{
    Header: t("remoteConfigurationHistory.date"),
    accessor: 'createdAt',
    format: 'date'
  },{
    Header: t("remoteConfigurationHistory.key"),
    accessor: 'key'
  },{
    Header: t("remoteConfigurationHistory.value"),
    accessor: 'value'
  },{
    Header: t("remoteConfigurationHistory.user"),
    accessor: 'user'
  },{
    Header: t("remoteConfigurationHistory.comment"),
    accessor: 'comment'
  }]);

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        {t("history")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
              data={data}
              columns={columns}
              {...tableProps}/>
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>

   );
}

export default RemoteConfigurationHistory;